import type { AnchorHTMLAttributes } from 'react'
import React from 'react'
import classNames from 'classnames'

import { toSafeUrl } from '../utils/useSafeUrl'
import type { BaseButtonProps } from './BaseButton'
import { BaseButton, BaseButtonContent } from './BaseButton'

export type ButtonHTMLLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> &
  Omit<BaseButtonProps, 'children'> & { href: string }

export const ButtonHTMLLink = ({
  variant,
  size,
  icon,
  iconPosition,
  iconSize,
  iconClassName,
  children,
  disabled,
  className: _className,
  style,
  isActive,
  transparent,
  align,
  ...props
}: ButtonHTMLLinkProps) => {
  const safeUrl = toSafeUrl(props.href)
  const isBlankTarget = !!props.target && props.target === '_blank'

  return (
    <BaseButton
      variant={variant}
      size={size}
      disabled={disabled}
      isActive={isActive}
      transparent={transparent}
      align={align}
    >
      {(outerClassName, outerStyle, innerClassName, innerStyle) => (
        <a
          {...props}
          href={safeUrl?.toString()}
          className={classNames(outerClassName, _className)}
          style={{ ...outerStyle, ...style }}
          rel={isBlankTarget ? 'noopener noreferrer' : props.rel}
        >
          <div className={innerClassName} style={innerStyle}>
            <BaseButtonContent
              icon={icon}
              content={children}
              size={size}
              iconClassName={iconClassName}
              iconPosition={iconPosition}
              iconSize={iconSize}
            />
          </div>
        </a>
      )}
    </BaseButton>
  )
}
